import Vue from 'vue'
import dayjs from 'dayjs'
require('dayjs/locale/fr')

dayjs.locale('fr')

Object.defineProperty(Vue.prototype, '$date', { value: dayjs })
